const iconNamePattern = /^[a-z0-9-]+$/;
let iconSpriteUrl;

function resolveIconSpriteUrl() {
    if (iconSpriteUrl !== undefined) return iconSpriteUrl;

    const existingUse = document.querySelector('.lucide use[href*="#icon-"]');
    const existingHref = existingUse?.getAttribute('href') || '';
    iconSpriteUrl = existingHref.includes('#')
        ? existingHref.slice(0, existingHref.indexOf('#'))
        : '';
    return iconSpriteUrl;
}

export function iconReference(name) {
    return iconNamePattern.test(name) ? `${resolveIconSpriteUrl()}#icon-${name}` : '';
}

export function createIcon(name, className = '') {
    if (!iconNamePattern.test(name)) return document.createTextNode('');

    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('class', `lucide lucide-${name}${className ? ` ${className}` : ''}`);
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');

    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttribute('href', iconReference(name));
    icon.append(use);
    return icon;
}

export function iconMarkup(name, className = '') {
    const icon = createIcon(name, className);
    return icon instanceof SVGElement ? icon.outerHTML : '';
}

export function setIcon(icon, name) {
    if (!(icon instanceof SVGElement) || !iconNamePattern.test(name)) return;

    [...icon.classList]
        .filter((className) => className.startsWith('lucide-'))
        .forEach((className) => icon.classList.remove(className));
    icon.classList.add(`lucide-${name}`);
    icon.querySelector('use')?.setAttribute('href', iconReference(name));
}
